import { getSettingFacebookMakerPixelId } from "@faire/retailer-visitor-shared/settings/getSettingFacebookMakerPixelId";
import debug from "debug";

/* docs: https://developers.facebook.com/docs/facebook-pixel/implementation */
declare function fbq(
  _: "trackSingle" | "trackSingleCustom",
  pixel: string,
  event: string,
  value?: object
): void;

const logger = debug("IF:FB");

enum FACEBOOK_STANDARD_EVENT {
  AddPaymentInfo = "AddPaymentInfo",
  AddToCart = "AddToCart",
  CompleteRegistration = "CompleteRegistration",
  Contact = "Contact",
  Donate = "Donate",
  InitiateCheckout = "InitiateCheckout",
  Lead = "Lead",
  PageView = "PageView",
  Purchase = "Purchase",
  Search = "Search",
  ViewContent = "ViewContent",
}

export const Facebook = {
  STANDARD: FACEBOOK_STANDARD_EVENT,
  sendMakerEvent: (eventName: FACEBOOK_STANDARD_EVENT, data?: object) => {
    logger(eventName);
    const facebookMakerPixelId = getSettingFacebookMakerPixelId();
    if (facebookMakerPixelId !== undefined) {
      fbq("trackSingle", facebookMakerPixelId, eventName, data);
    }
  },
  sendMakerCustomEvent: (eventName: string, data?: object) => {
    logger(eventName);
    const facebookMakerPixelId = getSettingFacebookMakerPixelId();
    if (facebookMakerPixelId !== undefined) {
      fbq("trackSingleCustom", facebookMakerPixelId, eventName, data);
    }
  },
};
